import { DefaultState, Filters } from 'store/types';

export const SET_REQUEST_TABLE_FILTERS = "SET_REQUEST_TABLE_FILTERS";

export type RequestTableFiltersState = DefaultState & {
  contents: Filters;
  exists: boolean;
};

interface SetRequestTableFilters {
  type: typeof SET_REQUEST_TABLE_FILTERS;
  contents: Filters;
  exists: boolean;
}

export type RequestTableFiltersActionTypes = SetRequestTableFilters;
